import { Field, Float, ID, InputType, ObjectType } from 'type-graphql'
import { Prop, PropType } from '@typegoose/typegoose'
import { RelatedEntity } from '../base/RelatedEntity'
import { Product } from '../product/Product'
import { UnitOfMeasure } from '../unitOfMeasure/UnitOfMeasure'
import { InventoryBySerialNumber } from '../inventorybyserialnumber/InventoryBySerialNumber'

/**
 * Embedded sub-document recording one production line scrapped by a destruct.
 * Its `_id` is the production line's `_id`, and `quantity` keeps the line's original
 * quantity as it stood at destruct time, so the record is auditable on its own.
 * Stored on WorkOrder by the Destructed transition.
 */
@ObjectType()
@InputType('WorkOrderScrappedItemInput')
export class WorkOrderScrappedItem {
  @Field(() => ID)
  @Prop({ type: String, required: true })
  _id: string

  @Field(() => Product)
  @Prop({ type: RelatedEntity })
  product: ReturnType<() => Product>

  @Field(() => UnitOfMeasure, { nullable: true })
  @Prop({ type: () => UnitOfMeasure })
  uom?: ReturnType<() => UnitOfMeasure>

  /**
   * The line's original quantity
   */
  @Field(() => Float)
  @Prop({ type: Number })
  quantity: number

  /**
   * Units of the line kept out of stock
   */
  @Field(() => Float)
  @Prop({ type: Number })
  scrappedQuantity: number

  /**
   * The serial numbers picked as scrapped on the line
   */
  @Field(() => [InventoryBySerialNumber])
  @Prop({ type: () => [InventoryBySerialNumber] }, PropType.ARRAY)
  inventoryBySerialNumbers?: ReturnType<() => InventoryBySerialNumber[]>
}
